import React from 'react'

const OutlineTickIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 18 18" fill="none">
            <path d="M3.09375 9.84375L7.03125 13.7812L14.9062 5.34375" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    )
}

export default OutlineTickIcon
